// extracted by mini-css-extract-plugin
module.exports = {"logoImage":"logo_logoImage__usfYl"};